import stl from "./LabelsCA.module.css";

const LabelsCA = (props) => {
  return (
    <>
      <div
        className={[
          stl.lblCAContainer,
          props.hasBrdr ? stl.hasBrdr : undefined,
        ].join(" ")}
      >
        {props.tags &&
          props.tags.map((tag, idx) => {
            return (
              <label
                  key={"lbl" + idx}
                  style={{
                  backgroundColor: tag.background_color
                    ? tag.background_color
                    : "",
                  color: tag.text_color ? tag.text_color : "",
                }}
              >
                {tag.icon && <img width="10px" src={tag.icon} alt="icon" />}
                <span>
                  {tag.tag_name} {tag.attr && <span>{tag.attr}</span>}
                </span>
              </label>
            );
          })}
      </div>
    </>
  );
};

export default LabelsCA;
